import { render, staticRenderFns } from "./TrustPilotWidget.vue?vue&type=template&id=5acd3e3a&"
import script from "./TrustPilotWidget.vue?vue&type=script&lang=ts&"
export * from "./TrustPilotWidget.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports